import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'container',
        component: () => import('@/views/container'),
        children: [
            {
                path: '',
                name: 'home',
				meta:{keepAlive:false},
                component: () => import('@/views/home/home'),
            },
            {
                path: 'find-job',
                name: 'find-job',
				// meta:{keepAlive:true},
                component: () => import('@/views/find-job/find-job'),
            },
            {
                path: 'job-detail',
                name: 'job-detail',
                component: () => import('@/views/find-job/job-detail'),
            },
            {
                path: 'store-detail',
                name: 'store-detail',
                component: () => import('@/views/find-job/store-detail'),
            },
            {
                path: 'find-careers',
                name: 'find-careers',
                component: () => import('@/views/find-careers/find-careers'),
            },
            {
                path: 'career-detail',
                name: 'career-detail',
                component: () => import('@/views/find-careers/career-detail'),
            },
            {
                path: 'course-list',
                name: 'course-list',
                component: () => import('@/views/course-list/course-list'),
            },
            {
                path: 'course-detail/:id',
                name: 'course-detail/:id',
                component: () => import('@/views/course-list/course-detail'),
            },
            {
                path: 'examination',
                name: 'examination',
                component: () => import('@/views/examination/examination')
            },
            {
                path: 'examination-detail',
                name: 'examination-detail',
                component: () => import('@/views/examination/examination-detail')
            },
            {
                path: 'online-operation',
                name: 'online-operation',
                component: () => import('@/views/examination/online-operation')
            },
            {
                path: 'online-operation-submit',
                name: 'online-operation-submit',
                component: () => import('@/views/examination/online-operation-submit')
            },
            {
                path: 'online-operation-result',
                name: 'online-operation-result',
                component: () => import('@/views/examination/online-operation-result')
            },
            {
                path: 'written-test',
                name: 'written-test',
                component: () => import('@/views/examination/written-test')
            },
            {
                path: 'written-test-result',
                name: 'written-test-result',
                component: () => import('@/views/examination/written-test-result')
            },
            {
                path: 'written-test-detail',
                name: 'written-test-detail',
                component: () => import('@/views/examination/written-test-detail')
            },
            {
                path: 'about-us',
                name: 'about-us',
                component: () => import('@/views/home/about-us'),
            },
            {
                path: 'mine',
                name: 'mine',
                component: () => import('@/views/mine/mine'),
            },
            {
                path: 'found-psw',
                name: 'found-psw',
                component: () => import('@/views/home/found-psw'),
            },
            {
                path: 'notice-list',
                name: 'notice-list',
                component: () => import('@/views/home/notice-list')
            },
            {
                path: 'notice-detail',
                name: 'notice-detail',
                component: () => import('@/views/home/notice-detail')
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login')
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

/**
 * 空路由重定向
 */
router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {  //如果未匹配到路由
        next({name:'home'})
    } else {
        next(); //如果匹配到正确跳转
    }
})
const originalPush = VueRouter.prototype.push
// 新增修改方法：修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
